<template>
  <div id='app'>
    <div v-if='!isLogin && checked' class='app-view'>
      <div class='app-body'>
        <div class='app-main'>
          <div class='welcome-logo'><img src='/images/logo/logo.png' class='welcome-img-logo'/></div>
          <el-form labelWidth='0px' label-position='right'>
            <el-form-item label='' label-position='left' style='margin-top: 10px;'>
              <el-input v-model='company' placeholder='请输入公司' disabled
                class='app-form-item company-select' size='samll'>
                <i slot='suffix' class='sys sys-company app-icon' style='color: lightgrey;'></i>
              </el-input>
            </el-form-item>

            <el-form-item label='' label-position='left' style='margin-top: -5px;'>
              <el-input v-model='userCode' placeholder='请输入账号'
                class='app-form-item usercode-input' size='samll'
                @keyup.enter.native='tapToPassword'
                :autofocus='true'>
                <i slot='suffix' class='sys sys-user app-icon' style='color: lightgrey;'></i>
              </el-input>
            </el-form-item>

            <el-form-item label='' label-position='left' style='margin-top: -5px;'>
              <el-input  type='password' v-model='password' placeholder='请输入密码'
                class='app-form-item password-input'
                ref='passwordInput' :show-password='false' size='samll'
                @keyup.enter.native='login'>
                <i slot='suffix' class='sys sys-password app-icon' style='color: lightgrey;'></i>
              </el-input>
            </el-form-item>
          </el-form>
          <div class='app-row' style='margin-top: -5px;'>
            <button @click='login' :class='allFill ? "app-loginBtn-allFill" : "app-loginBtn"' :disabled='!allFill'>登 录</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if='isLogin && checked' class='app-router-view'>
      <router-view/>
    </div>
  </div>
</template>

<script>
import axiosHelper from '@/utils/axiosHelper'
import cookieHelper from '@/utils/cookieHelper'
import code from '@/components/sys/Code'
import Layout from '@/layout'

export default {
  name: 'app',

  data: function () {
    return {
      isLogin: false,
      checked: false,
      companys: [{ code: '苏州埃博斯电气有限公司', name: '苏州埃博斯电气有限公司' }],
      company: '苏州埃博斯电气有限公司',
      userCode: '',
      password: '',
      allFill: false
    }
  },

  created: async function () {
    const that = this
    const rtnObj = await axiosHelper.handle('/WebSYSAction/User.IsLoginByToken', {}, function () {})
    if (rtnObj && rtnObj.error === '000000') {
      await that.getRoutes()
      const codes = await code.getAllCodes()
      that.$store.dispatch('commitCodes', codes)
      that.checked = true
      that.isLogin = true
    } else {
      const userInfoStr = cookieHelper.getCookie('userInfo')
      if (userInfoStr) {
        const userInfo = JSON.parse(decodeURI(userInfoStr))
        that.userCode = userInfo.UserCode
      }
      that.checked = true
    }
  },

  watch: {
    company: function (newVal, oldVal) {
      this.allFill = newVal.length > 0 && this.userCode.length > 0 && this.password.length > 0
    },
    userCode: function (newVal, oldVal) {
      this.allFill = this.company.length > 0 && newVal.length > 0 && this.password.length > 0
    },
    password: function (newVal, oldVal) {
      this.allFill = this.company.length > 0 && this.userCode.length > 0 && newVal.length > 0
    }
  },

  methods: {
    // 登录
    login: async function () {
      const that = this
      if (!that.userCode) {
        that.$message.error('请输入账号！')
        return
      }
      if (!that.password) {
        that.$message.error('请输入密码！')
        return
      }
      const rtnObj = await axiosHelper.handle('/WebSYSLogin', {
        userCode: that.userCode,
        password: that.password
      })
      if (rtnObj.error === '000000') {
        cookieHelper.setCookie('userInfo', JSON.stringify(rtnObj.userInfo), 1)
        that.$store.dispatch('commitUserInfo', rtnObj.userInfo)
        await that.getRoutes()
        const codes = await code.getAllCodes()
        that.$store.dispatch('commitCodes', codes)
        that.checked = true
        that.isLogin = true
      } else {
        that.$message.error(rtnObj.msg)
      }
    },

    // 获取路由数据
    getRoutes: async function () {
      const that = this
      const router = that.$router
      const rtnObj = await axiosHelper.handle('/WebAction/BaseData.User.GetUserAllMenuInfo', {})
      let menu1Infos = []
      if (rtnObj.error === '000000') {
        menu1Infos = rtnObj.data
      }
      this.$store.dispatch('commitUserMenus', menu1Infos)
      const ROUTES = []
      for (let i = 0; i < menu1Infos.length; i++) {
        const menu1 = menu1Infos[i]
        const menu2Infos = menu1.Children
        if (menu1.IsLeaf === '1') {
          const componentName = menu1.FilePath.indexOf('/') < 0 ? menu1.FilePath : menu1.FilePath.substring(menu1.FilePath.lastIndexOf('/') + 1)
          const ROUTE = {
            path: '/',
            component: Layout,
            name: '',
            meta: {
              title: ''
            },
            children: [{
              path: '/' + menu1.MenuCode,
              name: menu1.MenuName,
              component: () => import('@/views/' + menu1.FilePath),
              meta: {
                title: menu1.MenuName,
                componentName: componentName
              }
            }]
          }
          ROUTES.push(ROUTE)
        } else {
          const ROUTE = {
            path: '/' + menu1.MenuCode,
            component: Layout,
            name: menu1.MenuName,
            meta: {
              title: menu1.MenuName
            },
            children: []
          }
          for (let j = 0; j < menu2Infos.length; j++) {
            const componentName = menu2Infos[j].FilePath.indexOf('/') < 0 ? menu2Infos[j].FilePath : menu2Infos[j].FilePath.substring(menu2Infos[j].FilePath.lastIndexOf('/') + 1)
            const childROUTE = {
              path: menu2Infos[j].MenuCode.substring(menu1.MenuCode.length + 1),
              component: () => import('@/views/' + menu2Infos[j].FilePath),
              name: menu1.MenuName + ' | ' + menu2Infos[j].MenuName,
              meta: {
                title: menu2Infos[j].MenuName,
                componentName: componentName
              }
            }
            ROUTE.children.push(childROUTE)
          }
          ROUTES.push(ROUTE)
        }
      }
      router.addRoutes(ROUTES)
    },

    // 用户名输入框回车事件
    tapToPassword: function () {
      const that = this
      that.$refs.passwordInput.focus()
    }
  },

  metaInfo: {
    titleTemplate: '%s'
  }
}
</script>

<style scoped>
.app-view,
.app-body {
  position: relative;
  height: 100vh;
  overflow: hidden;
}
.app-body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  background-size: cover;
  background: url(/images/back/login.jpg) no-repeat 0px 0px;
  background-size:cover;
  background-attachment: fixed;
  background-position: 50%;
  position: relative;
  -webkit-background-size: cover;
  -o-background-size: cover;
}
.app-main {
  margin-right: 20%;
  margin-bottom: 5%;
  height: 298px;
  width: 308px;
  border: 1px solid #aaaaaa;
  background: rgba(256, 256, 256, 1);
  padding: 0px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  filter:alpha(Opacity=80);
  -moz-opacity:1;opacity: 1;
}
.welcome-logo {
  width: 208px;
  height: 50px;
}
.welcome-img-logo {
  width: 208px;
  height: 50px;
}
.welcome-row {
  height: 30px;
  width: 100%;
  padding-top: 10px;
  border-bottom: 1px solid #e8eaec;
}
.welcome-span {
  padding: 0 20px;
  font-size: 14px;
  font-weight: 800;
  color: #4E5155;
}
.app-icon {
  margin-left: 4px;
  color: black;
}
.app-form-item {
  width: 260px;
}
.company-select {
  color: black;
}
.company-row {
  height: 55px;
  width: 100%;
  margin-top: 10px;
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  color: #343E4C;
}
.company-span {
  width: 100%;
  margin-top: 20px;
}
.usercode-input {
  color: black;
}
.password-input {
  color: black;
}
.app-loginBtn {
  width: 262px;
  color: grey;
  font-size: 14px;
  display: block;
  margin: auto;
  height: 43px;
  line-height: 43px;
  border-radius: 5px;
  border: 0;
}
.app-loginBtn-allFill {
  width: 262px;
  color: #fff;
  font-size: 14px;
  display: block;
  margin: auto;
  height: 43px;
  line-height: 43px;
  border-radius: 5px;
  border: 0;
  background: #319AF2;
  background: linear-gradient(180deg,#319AF2 0%,#2386EE 100%);
}
.app-loginBtn-allFill:focus {
  border: 0;
  outline: 0;
}
.app-loginBtn-allFill:hover {
  -webkit-animation: gelatine 0.5s 1;
  animation: gelatine 0.5s 1;
}
.app-loginBtn-allFill:active {
  background: #2386EE;
}
.app-router-view {
  background-color: #f8f8f8;
  min-width: 640px;
  width: 100%;
  position: relative;
  height: 100vh;
}
</style>
